import { render, staticRenderFns } from "./DateFormatDateType.vue?vue&type=template&id=007ad2ca&"
import script from "./DateFormatDateType.vue?vue&type=script&lang=ts&"
export * from "./DateFormatDateType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports